export const PEOPLE_TEXT = Object.freeze({
  common: {
    noName: 'Sin nombre',
    defaultBadge: 'Principal',
  },
  card: {
    title: 'Personas de contacto',
    addButtonTitle: 'Agregar persona de contacto',
    addLabel: 'Agregar',
    empty: 'Sin personas de contacto registradas.',
    actions: {
      edit: 'Editar persona',
      delete: 'Eliminar persona',
    },
  },
  confirm: {
    titleDelete: 'Eliminar persona',
    subtitle: 'Confirma para continuar con esta operación.',
    messageDelete: (contactName) => `Contacto: ${contactName}\nEsta acción no se puede deshacer. ¿Deseas continuar con la eliminación?`,
    confirmButton: 'Eliminar',
  },
  toast: {
    deleteSuccess: 'Persona eliminada correctamente.',
    deleteError: 'No fue posible eliminar la persona.',
    createSuccess: 'Persona registrada correctamente.',
    updateSuccess: 'Persona actualizada correctamente.',
    saveError: 'No fue posible guardar la persona.',
  },
  modal: {
    closeAriaLabel: 'Cerrar modal',
    formSectionsAriaLabel: 'Secciones del formulario de persona',
    titleCreate: 'Nueva persona de contacto',
    titleEdit: 'Editar persona de contacto',
    subtitleCreate: 'Captura la información de contacto y rol dentro de la empresa.',
    subtitleEdit: 'Actualiza la información de contacto y rol dentro de la empresa.',
    submitCreate: 'Guardar',
    submitEdit: 'Guardar cambios',
    cancel: 'Cancelar',
    sections: {
      basic: {
        title: 'Información básica',
        description: 'Nombre, puesto y cumpleaños.',
      },
      contact: {
        title: 'Contacto',
        description: 'Correos y teléfonos directos.',
      },
      role: {
        title: 'Rol y Notificaciones',
        description: 'Funciones para facturación y cobranza.',
      },
      address: {
        title: 'Dirección',
        description: 'País, estado, ciudad y código postal.',
      },
    },
    validation: {
      firstNameRequired: 'El nombre es obligatorio.',
      emailInvalid: 'El email no es válido.',
    },
  },
});